// @ts-check
import { useEffect, useState } from "react"
import { getClientSprintLog } from "../../../../../services/clientReport.service"

/** @param {number} clientId */
export function useClientSprintsTableData(clientId) {
  const [loading, setLoading] = useState(false)
  const [sprintsData, setSprintsData] = useState(
    /** @type {import("../../../../../services/clientReport.service.types").ClientSprintLogEntry[]} */ ([])
  )

  /** @param {number} clientId */
  async function getSprintsData(clientId) {
    if (!clientId) return

    setLoading(true)
    const response = await getClientSprintLog(clientId)
    if (response.success) {
      setSprintsData(response.result)
    } else {
      console.error("Error fetching sprints data:", response.error)
      setSprintsData([])
    }
    setLoading(false)
  }

  useEffect(() => {
    getSprintsData(clientId)
  }, [clientId])

  return { sprintsData, loading }
}
